import React, { useEffect, useState } from 'react';
import { businessInfo } from '../data/mock';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactFormDialog from '../components/ContactFormDialog';

const Privacy = () => {
  const [isContactDialogOpen, setIsContactDialogOpen] = useState(false);

  useEffect(() => {
    // Set meta title
    document.title = 'Privacy Policy | Trademark Restaurant Name';
    
    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'Privacy Policy for Trademark Restaurant Name. Learn how we collect, use, and protect your personal information when you use our trademark registration services.';
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onContactClick={() => setIsContactDialogOpen(true)} />
      
      {/* Content */}
      <div className="container mx-auto px-4 py-32">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-[#1e3a5f] mb-8">Privacy Policy</h1>

          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Introduction</h2>
              <p className="leading-relaxed">
                {businessInfo.name} ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our trademark registration services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Information We Collect</h2>
              <p className="leading-relaxed mb-3">We collect information that you provide directly to us, including:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Personal identification information (name, email address, phone number)</li>
                <li>Business information (company name, trademark details)</li>
                <li>Payment information (processed securely through third-party payment processors)</li>
                <li>Communication records and correspondence</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">How We Use Your Information</h2>
              <p className="leading-relaxed mb-3">We use the information we collect to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide, maintain, and improve our trademark registration services</li>
                <li>Process your applications and communicate with you about your trademark</li>
                <li>Send you updates, marketing communications, and other information (with your consent)</li>
                <li>Respond to your inquiries and provide customer support</li>
                <li>Comply with legal obligations and protect our rights</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Information Sharing</h2>
              <p className="leading-relaxed">
                We do not sell your personal information. We may share your information with third parties only in the following circumstances: with your consent, to comply with legal obligations, with service providers who assist in our operations, or to protect our rights and safety.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Data Security</h2>
              <p className="leading-relaxed">
                We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Your Rights</h2>
              <p className="leading-relaxed mb-3">You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access and receive a copy of your personal information</li>
                <li>Correct inaccurate or incomplete information</li>
                <li>Request deletion of your personal information</li>
                <li>Object to or restrict certain processing activities</li>
                <li>Withdraw consent at any time</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mb-3">Contact Us</h2>
              <p className="leading-relaxed mb-3">
                If you have questions about this Privacy Policy, please contact us:
              </p>
              <ul className="space-y-2">
                <li>Email: {businessInfo.email}</li>
                <li>Phone: {businessInfo.phone}</li>
                <li>Address: {businessInfo.address}</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
      
      <ContactFormDialog
        open={isContactDialogOpen}
        onOpenChange={setIsContactDialogOpen}
      />
      
      <Footer />
    </div>
  );
};

export default Privacy;
